export class BackendValidator {
    id: number | undefined;
    entity: string | undefined;
    code: string | undefined;
    description: string | undefined;
    creationDate: Date | undefined;
    lastUpdate: Date | undefined;
    expirationDate: Date | undefined;
}
